"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("@emotion/react");
// eslint-disable-next-line complexity
function compileBgStyleString(bg = {}) {
    const { bgCustom, bgImg, bgSelected, colors } = bg;
    let appBg = '';
    switch (bgSelected) {
        case 'color':
            if (colors === null || colors === void 0 ? void 0 : colors.bg)
                appBg = colors.bg;
            break;
        case 'image':
            if (bgImg === null || bgImg === void 0 ? void 0 : bgImg.src)
                appBg = `url(${bgImg.src}) no-repeat center/cover`;
            break;
        case 'custom':
            if (bgCustom)
                appBg = bgCustom;
            break;
        default:
            break;
    }
    if (!appBg)
        return '';
    return `{
        --app-bg: ${appBg};
    }`;
}
function brandingBgStyles(branding = {}) {
    const { darkTheme } = branding;
    const lightThemeString = compileBgStyleString(branding);
    if (darkTheme && compileBgStyleString(darkTheme)) {
        const darkThemeString = compileBgStyleString(Object.assign(Object.assign({}, branding), darkTheme));
        return (0, react_1.css) `
            :root ${lightThemeString}

            .pythia-surveys-root[data-theme='light'] ${lightThemeString}
            .pythia-surveys-root[data-theme='dark'] ${darkThemeString}
        `;
    }
    return (0, react_1.css) `
        :root ${lightThemeString}

        .pythia-surveys-root[data-theme='light'] ${lightThemeString}
    `;
}
exports.default = brandingBgStyles;
